module.exports = __webpack_public_path__ + "static/img/wechat-tip.e56cff36.png";